import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const EmailVerified = () => {
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);

  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.EmailVerified.s4',
    'You have verified your email address - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const handleBtnClick = () => {
    history.push('/pmcReg/contact-details');
  };

  return (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.EmailVerified.s1',
          'You have verified your email address'
        )}
      </h1>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy('landlordReg.EmailVerified.s3', 'Continue')}
      </Button>
    </>
  );
};

export default EmailVerified;
